/**
 * PDP gift bag + gift note. Bag is a separate SKU; note is a line property
 * and cart attribute. Shop Pay is hidden while a bag is selected.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-gift-options]');
  if (!root) return;

  var productForm = root.closest('.product_form');
  var bag = root.querySelector('[data-gift-bag-checkbox]');
  var note = root.querySelector('[data-gift-note]');
  var toggle = root.querySelector('[data-gift-options-toggle]');
  var mobileMq = window.matchMedia('(max-width: 798px)');

  function syncGiftDisclosure(isMobile) {
    if (!toggle) return;

    if (!isMobile) {
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      return;
    }

    root.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle) {
    syncGiftDisclosure(mobileMq.matches);
    toggle.addEventListener('click', function () {
      if (!mobileMq.matches) return;

      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', function (event) {
        syncGiftDisclosure(event.matches);
      });
    }
  }

  function setBagSelected(on) {
    if (productForm) {
      productForm.classList.toggle('yt-gift-bag-selected', on);
    }

    var pay = productForm && productForm.querySelector('.shopify-payment-button');
    if (pay) {
      pay.hidden = on;
      pay.setAttribute('aria-hidden', on ? 'true' : 'false');
    }
  }

  if (bag) {
    bag.addEventListener('change', function () {
      setBagSelected(bag.checked);
    });
    setBagSelected(bag.checked);
  }

  function saveNoteAttribute(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift note': value } })
    });
  }

  function syncNoteFieldName() {
    if (!note) return;
    if (note.value.trim()) {
      note.setAttribute('name', 'properties[Gift note]');
    } else {
      note.removeAttribute('name');
    }
  }

  var noteCount = root.querySelector('[data-gift-note-count]');

  function updateNoteCount() {
    if (!noteCount || !note) return;

    var max = note.getAttribute('maxlength');
    if (!max) return;

    noteCount.textContent = note.value.length + ' / ' + max;
  }

  if (note) {
    var noteTimer;
    syncNoteFieldName();
    updateNoteCount();
    note.addEventListener('input', function () {
      syncNoteFieldName();
      updateNoteCount();
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        saveNoteAttribute(note.value.trim());
      }, 400);
    });
  }

  function giftBagItems(cart, variantId) {
    return (cart.items || []).filter(function (item) {
      if (!item) return false;
      if (variantId && Number(item.variant_id) === Number(variantId)) return true;
      if (item.handle === 'gift-bag') return true;
      return item.sku === 'GIFTB-DS-A4';
    });
  }

  function updateBagQuantities(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function addGiftBag(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function addOrIncrementGiftBag(variantId) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var bags = giftBagItems(cart, variantId);
        if (!bags.length) return addGiftBag(variantId);

        var updates = {};
        updates[bags[0].key] = Number(bags[0].quantity || 0) + 1;
        bags.slice(1).forEach(function (bag) {
          if (bag.key) updates[bag.key] = 0;
        });
        return updateBagQuantities(updates);
      });
  }

  window.YTGiftOptions = {
    afterProductAdd: function (formEl) {
      var box = (formEl && formEl.querySelector('[data-gift-options]')) || root;
      if (!box) return Promise.resolve();

      var bagBox = box.querySelector('[data-gift-bag-checkbox]');
      var noteBox = box.querySelector('[data-gift-note]');
      var variantId = parseInt(box.getAttribute('data-gift-bag-variant'), 10);
      var tasks = [];

      if (noteBox && noteBox.value.trim()) {
        tasks.push(saveNoteAttribute(noteBox.value.trim()).catch(function () {}));
      }

      if (bagBox && bagBox.checked && variantId) {
        tasks.push(addOrIncrementGiftBag(variantId).catch(function () {}));
      }

      return Promise.all(tasks);
    }
  };
})();
